(function () {
  if (window.__TIRE_SIZE_NORMALIZER__) return;
  window.__TIRE_SIZE_NORMALIZER__ = true;

  const qs = (s, r = document) => { try { return r.querySelector(s); } catch { return null; } };

  function getInput() {
    return qs(".ais-SearchBox-input") || qs(".ais-search-box input");
  }

  // 22540 -> 225/40
  function normalizePartialSize(raw) {
    const s = String(raw || "").trim().toUpperCase();

    // Si ya tiene "/" o "R", no tocamos (ya está formateado)
    if (s.includes("/") || s.includes("R")) return null;

    // 5 dígitos: 22540 => 225/40
    if (/^\d{5}$/.test(s)) {
      const w = s.slice(0, 3);
      const a = s.slice(3, 5);
      const wi = Number(w), ai = Number(a);

      // validaciones suaves
      if (wi < 135 || wi > 405) return null;
      if (ai < 20 || ai > 95) return null;

      return `${w}/${a}`;
    }

    // 7 dígitos: 2254018 => 225/40R18
    if (/^\d{7}$/.test(s)) {
      const w = s.slice(0, 3);
      const a = s.slice(3, 5);
      const r = s.slice(5, 7);
      const wi = Number(w), ai = Number(a), ri = Number(r);

      if (wi < 135 || wi > 405) return null;
      if (ai < 20 || ai > 95) return null;
      if (ri < 12 || ri > 30) return null;

      return `${w}/${a}R${r}`;
    }

    return null;
  }

  let applying = false;
  let lastNormalized = "";

  function onInput() {
    if (applying) return;

    const input = getInput();
    if (!input) return;

    const raw = input.value || "";
    const normalized = normalizePartialSize(raw);

    if (!normalized) return;
    if (normalized === lastNormalized) return;

    applying = true;
    lastNormalized = normalized;

    // ✅ Aquí está la magia: cambiamos el query real de Algolia
    input.value = normalized;

    // ✅ dispara búsqueda (actualiza grilla)
    input.dispatchEvent(new Event("input", { bubbles: true }));

    // caret al final
    try {
      input.focus();
      input.setSelectionRange(normalized.length, normalized.length);
    } catch {}

    setTimeout(() => { applying = false; }, 0);
  }

  function bind() {
    const input = getInput();
    if (!input || input.dataset.tireSizeNormalizerBound === "1") return;

    input.dataset.tireSizeNormalizerBound = "1";
    input.addEventListener("input", onInput);
  }

  // Bind cuando el overlay y AIS ya renderizaron
  window.addEventListener("ais-rendered", () => setTimeout(bind, 0));
  window.addEventListener("improved-search:opened", () => setTimeout(bind, 0));
  window.addEventListener("improved-search:ready", () => setTimeout(bind, 0));
  window.addEventListener("load", () => setTimeout(bind, 0));
})();
